// Google Analytics 4, Meta Pixel, Microsoft Clarity utilities

const GA4_ID = 'G-L58M020BD3';
const META_PIXEL_ID = '1240353220682655';
const CLARITY_ID = 'fdrwics2gl';

// Initialize GA4 (script loaded in index.html, this ensures gtag is available)
export const initGA4 = () => {
  if (typeof window !== 'undefined' && !window.gtag) {
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA4_ID);
  }
};

// Initialize Meta Pixel
export const initMetaPixel = () => {
  if (typeof window !== 'undefined' && !window.fbq) {
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }
};

// Initialize Microsoft Clarity
export const initClarity = () => {
  if (typeof window !== 'undefined' && !window.clarity) {
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", CLARITY_ID);
  }
};

// Track custom events
export const trackEvent = (eventName, eventCategory, eventData = {}) => {
  // GA4 Event
  if (window.gtag) {
    window.gtag('event', eventName, {
      event_category: eventCategory,
      ...eventData
    });
  }

  // Meta Pixel Event
  if (window.fbq) {
    window.fbq('trackCustom', eventName, eventData);
  }

  // Also send to backend for storage
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  fetch(`${BACKEND_URL}/api/analytics/event`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      event_name: eventName,
      event_category: eventCategory,
      event_data: eventData,
      user_agent: navigator.userAgent
    })
  }).catch(err => console.log('Analytics tracking error:', err));
};

// Track page views
export const trackPageView = (pagePath, pageTitle) => {
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle
    });
  }
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
};

// Track CTA clicks
export const trackCTAClick = (ctaName, ctaLocation) => {
  trackEvent('cta_click', 'engagement', { cta_name: ctaName, cta_location: ctaLocation });
};

// Track form submissions
export const trackFormSubmit = (formName, formData = {}) => {
  trackEvent('form_submit', 'conversion', { form_name: formName, ...formData });
  if (window.fbq) {
    window.fbq('track', 'Lead', { content_name: formName });
  }
};

// Track product views
export const trackProductView = (productId, productName) => {
  trackEvent('product_view', 'engagement', { product_id: productId, product_name: productName });
  if (window.fbq) {
    window.fbq('track', 'ViewContent', { content_ids: [productId], content_name: productName });
  }
};

// Track Easter Egg triggers
export const trackEasterEgg = (eggName, promoCode) => {
  trackEvent('easter_egg_triggered', 'engagement', { egg_name: eggName, promo_code: promoCode });
};
